export const _logInUser = process.env.REACT_APP_BASE_URL + "/auth"
export const _logInAdmin = process.env.REACT_APP_BASE_URL + "/admin/auth"
export const _getAllAdmin = process.env.REACT_APP_BASE_URL + "/admin/get/all"
export const _getSingleAdmin = process.env.REACT_APP_BASE_URL + "/admin/get"
export const _postAdmin = process.env.REACT_APP_BASE_URL + "/admin/add"
export const _getAllAdminClient = process.env.REACT_APP_BASE_URL + "/client/get/all"
export const _getSingleAdminClient = process.env.REACT_APP_BASE_URL + "/client/get"
export const _postAdminClient = process.env.REACT_APP_BASE_URL + "/client/register"
export const _upDateAdminClient = process.env.REACT_APP_BASE_URL + "/client/update"
export const _upDateAdmin = process.env.REACT_APP_BASE_URL + "/admin/update"
export const _delteAdmin = process.env.REACT_APP_BASE_URL + "/admin/remove"
export const _deleteClient = process.env.REACT_APP_BASE_URL + "/client/remove"
export const _getSingleMenu = process.env.REACT_APP_BASE_URL + "/menu/get"
export const _getAllMenu = process.env.REACT_APP_BASE_URL + "/menu/get/all"
export const _postMenu = process.env.REACT_APP_BASE_URL + "/menu/add"
export const _upDateMenu = process.env.REACT_APP_BASE_URL + "/menu/update"
export const _deleteMenu = process.env.REACT_APP_BASE_URL + "/menu/remove"
export const _getSingleGroupMenu = process.env.REACT_APP_BASE_URL + "group/get"
export const _getAllGroupMenu = process.env.REACT_APP_BASE_URL + "/group/get/all"
export const _postGroupMenu = process.env.REACT_APP_BASE_URL + "/group/add"
export const _upDateGroupMenu = process.env.REACT_APP_BASE_URL + "/group/update"
export const _deleteGroupMenu = process.env.REACT_APP_BASE_URL + "/group/remove"
export const _getSingleWidget = process.env.REACT_APP_BASE_URL + "/widget/get"
export const _getAllWidget = process.env.REACT_APP_BASE_URL + "/widget/get/all"
export const _postWidget = process.env.REACT_APP_BASE_URL + "/widget/add"
export const _upDateWidget = process.env.REACT_APP_BASE_URL + "/widget/update"
export const _deleteWidget = process.env.REACT_APP_BASE_URL + "/widget/remove"
export const _getClientMenu = process.env.REACT_APP_BASE_URL + "/menu/client"